import {
  musicUploadAsTrack,
  useListMusicUploads,
} from '@/features/music/api/music-uploads.hook';
import {
  type MusicChoice,
  MusicEditorDialog,
} from '@/features/music/components/music-editor-dialog';
import { useListMusicTracks } from '@/features/videos/api/list-music-tracks';

/** Loads the shared and organization music libraries only while it is open. */
export function ContentMusicEditor({
  open,
  onOpenChange,
  value,
  onSave,
  saving,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: MusicChoice;
  onSave: (choice: MusicChoice) => void | Promise<void>;
  saving?: boolean;
}) {
  const { tracks, isLoading } = useListMusicTracks(open);
  const { uploads, isLoading: uploadsLoading } = useListMusicUploads(open);

  return (
    <MusicEditorDialog
      open={open}
      onOpenChange={onOpenChange}
      tracks={[...uploads.map(musicUploadAsTrack), ...tracks]}
      isLoading={isLoading || uploadsLoading}
      value={value}
      onSave={onSave}
      saving={saving}
    />
  );
}
